import { Link, NavLink } from 'react-router-dom'
import { motion, useCycle, AnimatePresence } from 'framer-motion'
import logo from '../assets/images/logo.avif'
import { useTranslation } from 'react-i18next'

export default function Navbar() {
  const [t, i18n] = useTranslation()
  const changeLang = (lang) => {
    i18n.changeLanguage(lang)
  }

  const navlinks = [
    { title: t('navLink.about'), href: '/' },
    { title: t('navLink.properties'), href: '/properties' },
    { title: t('navLink.services'), href: '/services' },
    { title: t('navLink.topOffers'), href: '/topProperties' },
    { title: t('navLink.news'), href: '/news' },
    { title: t('navLink.contacts'), href: '/contact' },
  ]

  const [mobileNav, toggleMobileNav] = useCycle(false, true)
  return (
    <header className='fixed top-0 z-50 bg-black backdrop-blur-lg  w-full shadow-md sm:pr-4'>
      <div className='flex flex-row items-center align-middle justify-between pr-2 sm:pr-0'>
        <div className='flex items-center gap-24'>
          <Link
            to='/'
            className='flex items-center gap-2'
          >
            <img
              src={logo}
              alt='logo'
              className='w-14 sm:w-12 h-14 sm:h-12 rounded-sm sm:rounded-none'
            />
            <p className='font-bold text-xl gold'>Hygge Hurghada Home</p>
          </Link>
          <nav className='hidden sm:flex items-center font-bold text-center text-sm gold'>
            {navlinks.map(({ href, title }) => {
              return (
                <NavLink
                  key={title}
                  to={href}
                  className={({ isActive }) =>
                    isActive
                      ? 'active-link underline'
                      : 'hover:underline transition-all duration-200 h-12 flex items-center px-2'
                  }
                >
                  {title}
                </NavLink>
              )
            })}
          </nav>
        </div>
        <div className='relative z-50 px-3 py-[15px]'>
          <motion.button
            animate={mobileNav ? 'open' : 'closed'}
            onClick={() => toggleMobileNav()}
            className='flex flex-col space-y-1'
          >
            <motion.span
              variants={{
                closed: { rotate: 0, y: 0 },
                open: { rotate: 45, y: 6 },
              }}
              className='w-5 h-[2px] rounded-full btn block'
            />
            <motion.span
              variants={{
                closed: { opacity: 1 },
                open: { opacity: 0 },
              }}
              className='w-5 h-[2px] rounded-full btn block'
            />
            <motion.span
              variants={{
                closed: { rotate: 0, y: 0 },
                open: { rotate: -45, y: -6 },
              }}
              className='w-5 h-[2px] rounded-full btn block'
            />
          </motion.button>
        </div>
        <AnimatePresence>
          {mobileNav && (
            <motion.div
              key='mobile-nav'
              variants={{
                open: { x: '0%' },
                closed: { x: '100%' },
              }}
              initial='closed'
              animate='open'
              exit='closed'
              transition={{
                x: { type: 'spring', stiffness: 300, damping: 40 },
                opacity: { duration: 0.2 },
              }}
              className='fixed right-0 top-0 w-[90%] md:w-1/2 lg:w-1/3 bg-black z-40 px-6'
            >
              <div className='flex items-center gap-2 text-sm m-4 text-zinc-300'>
                <button
                  className='bg-white/10 hover:bg-white/20 p-2 rounded-sm transition-all duration-200'
                  onClick={() => changeLang('en')}
                >
                  EN
                </button>
                <span>/</span>
                <button
                  className='bg-white/10 hover:bg-white/20 p-2 rounded-sm transition-all duration-200'
                  onClick={() => changeLang('ru')}
                >
                  RU
                </button>
              </div>
              <nav
                onClick={() => toggleMobileNav()}
                className='flex flex-col justify-center items-end gap-4 h-screen w-full text-black text-xl sm:text-3xl pl-4 sm:pl-12 text-end'
              >
                {navlinks.map(({ href, title }) => {
                  return (
                    <NavLink
                      key={title}
                      to={href}
                      className={({ isActive }) =>
                        isActive
                          ? 'active-link underline gold'
                          : ' hover:underline transition-all duration-200 h-12 flex items-center p-2 gold'
                      }
                    >
                      {title}
                    </NavLink>
                  )
                })}
              </nav>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  )
}
